import { render } from "./id_form.html?vue&type=template&id=5f9faa1c&external"
import script from "./id_form.js?vue&type=script&lang=js&external"
export * from "./id_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__